import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Header from 'containers/PasswordRecoveryPages/Header';
import messages from 'containers/PasswordRecoveryPages/InsertIdentifiant/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/PasswordRecoveryPages/InsertIdentifiant/Form';
import { pushTo } from 'helpers/routes';
import PAGES from 'routes/pages';
import { StyledPrimaryButton } from 'containers/PasswordRecoveryPages/InsertIdentifiant/styles';
import { getErrorMessageSelector } from 'store/credentials/selectors';
import { submitPasswordRecoveryStepFail } from 'store/credentials/actions';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import FormOrganisme from './FormOrganisme';

const InsertIndentifiant = (props: {
  intl: IntlShape;
  isLoading: boolean;
  onSubmitStep: Function;
  errorMessage?: string;
  hasAmc?: boolean | undefined;
}) => {
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.RECOVERY_PASSWORD}
      label="chargement de la page"
    >
      <>
        <Header
          title={translate({ ...messages.formTitle }, props)}
          subTitle={translate({ ...messages.formSubTitle }, props)}
        />
        {props.hasAmc ? (
          <FormOrganisme
            onSubmit={props.onSubmitStep}
            errorMessage={props.errorMessage}
            loader={props.isLoading}
          />
        ) : (
          <Form
            onSubmit={props.onSubmitStep}
            errorMessage={props.errorMessage}
            loader={props.isLoading}
          />
        )}
        {!props.hasAmc && (
          <Box paddingX={[2, 4, 8]}>
            <GaClickHOC
              category={EVENT_CATEGORIES.RECOVERY_PASSWORD}
              label="Identifiant oublié"
            >
              <StyledPrimaryButton
                data-testid="identifiant-oublie"
                variant="outlined"
                onClick={() => {
                  pushTo(PAGES.RECOVERYLOGIN);
                  submitPasswordRecoveryStepFail('');
                }}
              >
                {translate({ ...messages.forgotLogin }, props)}
              </StyledPrimaryButton>
            </GaClickHOC>
          </Box>
        )}
      </>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<any, { errorMessage: string }>(
  {
    errorMessage: getErrorMessageSelector,
  },
);

export default connect(mapStateToProps, null)(injectIntl(InsertIndentifiant));
